var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.722,
    height: 20.423,
    viewBox: "0 0 27.722 20.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12209",
    "data-name": "Group 12209",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12206",
    "data-name": "Group 12206",
    transform: "translate(0 5.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12205",
    "data-name": "Group 12205",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49653",
    "data-name": "Path 49653",
    d: "M14.663,155.153a1.576,1.576,0,0,1-1.636,0L0,147.2v10.572a4.093,4.093,0,0,0,4.091,4.091h19.54a4.093,4.093,0,0,0,4.091-4.091V147.2Z",
    transform: "translate(0 -147.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12208",
    "data-name": "Group 12208",
    transform: "translate(0.131 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12207",
    "data-name": "Group 12207",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49654",
    "data-name": "Path 49654",
    d: "M25.548,57.088H6.008A4.067,4.067,0,0,0,2.048,60.3l13.746,8.379L29.508,60.3A4.067,4.067,0,0,0,25.548,57.088Z",
    transform: "translate(-2.048 -57.088)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailDoc);
export default __webpack_public_path__ + "static/media/mailDoc.10e0b69d06531b6467072973fc1bf50b.svg";
export { ForwardRef as ReactComponent };